import Container from 'components/molecules/Container/Container';
import NavbarWithBackLink from 'components/molecules/NavbarWithBackLink/NavbarWithBackLink';
import { HelmetAndPageAnnouncer } from 'components/organisms/HelmetAndPageAnnouncer/HelmetAndPageAnnouncer';
import { FormType } from 'generated/graphql';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader } from '@spotted-zebra-uk/ui-components';
import StageActionFormView from 'views/StageActionForm/StageActionFormView';
import { useRoleStageActionsFlow } from './useRoleStageActionsFlow';

const RoleStageForm: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { formType } = useParams();
  const { role, stage, loading, exiting, actionsUrl } =
    useRoleStageActionsFlow();

  if (loading) {
    return (
      <Container className="page-loader-wrapper">
        <Loader variant="bubbles" />
      </Container>
    );
  }

  if (exiting || !role || !stage || !formType) {
    return null;
  }

  return (
    <>
      <HelmetAndPageAnnouncer pageTitle={t('assessment.generalQuestions')} />
      <NavbarWithBackLink
        to={actionsUrl}
        ariaLabel={t('assessment.returnToAllAssessmentActions')}
        label={t('assessment.actions')}
      />
      <StageActionFormView
        ownerId={role.company.id}
        stageCandidateId={stage.stageCandidateId}
        formType={formType as FormType}
        onSaveCompleted={() => navigate(actionsUrl)}
      />
    </>
  );
};

export default RoleStageForm;
